import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65193269"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "context" }
const _hoisted_3 = { class: "title g-f16 g-clame2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "info g-mt30 g-f14 g-flex-al-center" }
const _hoisted_6 = { class: "star g-flex-al-center" }
const _hoisted_7 = { class: "g-ml5" }
const _hoisted_8 = { class: "preview g-flex-al-center" }
const _hoisted_9 = { class: "g-ml5" }

import { ElIcon } from "element-plus";
import { StarFilled, View } from "@element-plus/icons-vue";
import { withDefaults, computed } from "vue";
import { courseItemType } from "@/api/request/courseCenter";
import Tea from "@dp/byted-tea-sdk-oversea";
// import { useRouter } from "vue-router";
// const router = useRouter();


export default /*#__PURE__*/_defineComponent({
  __name: 'CourseItem',
  props: {
    theme: { default: "black" },
    width: { default: "338px" },
    data: null,
    courseId: { default: "" },
    source: null,
    border: { type: Boolean }
  },
  setup(__props: any) {

const $props = __props as { theme: "black" | "white", width: string, data: courseItemType, courseId: string, source?: string, border?: boolean };

function goRouter() {
  Tea.event("enter_course", {
    source: $props.source,
    id: $props.courseId || $props.data.businessId,
  });
  if ($props.source === "index_high_quality_course") {
    Tea.event("home_course_click", {
      course_name: $props.data.name,
      source: "highCourse",
      client: "PC",
    });
  }
  window.open(
    window.location.origin +
      "/operate/courseContent?id=" +
      ($props.courseId || $props.data.businessId)
  );
  // router.push({
  //   path: "/operate/courseContent",
  //   query: {
  //     id: $props.courseId || $props.data.id,
  //   },
  // });
}



const widthClass = computed(() => {
  return `width-${$props.width}`;
});

const avatarHeightClass = computed(() => {
  return $props.width === '338px' || $props.width === '317px' || $props.width === '385px' ? 'avatar-height-190' : 'avatar-height-258';
});

return (_ctx: any,_cache: any) => {
  const _directive_cdn = _resolveDirective("cdn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[__props.theme === 'white' ? 'white' : 'black', __props.border ? 'border' : '', _unref(widthClass)], "item g-pointer"]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (goRouter()))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["avatar", _unref(avatarHeightClass)])
    }, [
      _withDirectives(_createElementVNode("img", {
        src: __props.data.cover,
        alt: ""
      }, null, 8, _hoisted_1), [
        [_directive_cdn]
      ])
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (__props.data.className)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.data.className) + " |", 1))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(__props.data.name), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('评分')) + "：" + _toDisplayString(__props.data.realScore), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('浏览量')) + "：" + _toDisplayString(__props.data.realPageView), 1)
        ])
      ])
    ])
  ], 2))
}
}

})